import { Label } from "@/components/ui/label";

interface RequiredLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
  hint?: string;
  error?: string | null;
  className?: string;
}

export function RequiredLabel({
  htmlFor,
  children,
  required,
  hint,
  error,
  className,
}: RequiredLabelProps) {
  return (
    <div className="flex items-baseline justify-between gap-2">
      <Label htmlFor={htmlFor} className={className ?? "inline-flex items-center gap-1"}>
        {children}
        {required ? (
          <span className="text-red-500" aria-hidden="true">
            *
          </span>
        ) : null}
      </Label>
      {error ? (
        <span className="text-xs text-red-600">{error}</span>
      ) : hint ? (
        <span className="text-xs text-slate-400">{hint}</span>
      ) : null}
    </div>
  );
}
